var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/document"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3337 8.33268V12.4993C18.3337 16.666 16.667 18.3327 12.5003 18.3327H7.50033C3.33366 18.3327 1.66699 16.666 1.66699 12.4993V7.49935C1.66699 3.33268 3.33366 1.66602 7.50033 1.66602H11.667",
    stroke: "#1D2023",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.3337 8.33268H15.0003C12.5003 8.33268 11.667 7.49935 11.667 4.99935V1.66602L18.3337 8.33268Z",
    stroke: "#1D2023",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.f45284fe20bcc2a6be6bc84de8128ca5.svg";
export { ForwardRef as ReactComponent };